enum ActiveInspectionStatus {
    null = 0,
    Unsaved = 1,
    Saved = 2,
}

export default ActiveInspectionStatus;
